/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1PersonIdAttachmentsMutationRequest,
  PostApiV1PersonIdAttachmentsMutationResponse,
  PostApiV1PersonIdAttachmentsPathParams,
  PostApiV1PersonIdAttachments400,
  PostApiV1PersonIdAttachments401,
  PostApiV1PersonIdAttachments404,
  PostApiV1PersonIdAttachments500,
} from "../../types/personDocumentsController/PostApiV1PersonIdAttachments.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPostApiV1PersonIdAttachmentsUrl(
  id: PostApiV1PersonIdAttachmentsPathParams["id"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/person/${id}/attachments` as const,
  };
  return res;
}

/**
 * @description Upload de anexo de matrícula. Body multipart: classStudentId (opcional, contexto da turma), enrollmentDocumentId (tipo de documento) e file. **(Requer Authorization para autenticação)**
 * @summary Criar anexo de matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/attachments}
 */
export async function postApiV1PersonIdAttachments(
  id: PostApiV1PersonIdAttachmentsPathParams["id"],
  data?: PostApiV1PersonIdAttachmentsMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1PersonIdAttachmentsMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiV1PersonIdAttachmentsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAttachments400
      | PostApiV1PersonIdAttachments401
      | PostApiV1PersonIdAttachments404
      | PostApiV1PersonIdAttachments500
    >,
    PostApiV1PersonIdAttachmentsMutationRequest
  >({
    method: "POST",
    url: getPostApiV1PersonIdAttachmentsUrl(id).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
